import {
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { DashboardWidgetComponent, DashboardWidgetInstance } from '../models/dashboard-widget.types';
import { DashboardWidgetRegistryService } from '../registry/dashboard-widget-registry.service';

@Component({
  selector: 'jbm-dashboard-widget-host',
  template: '<ng-container #host></ng-container>'
})
export class JBMDashboardWidgetHostComponent implements OnChanges, OnDestroy {
  @Input() widget!: DashboardWidgetInstance;
  @Output() titleChange = new EventEmitter<string>();
  @Output() iconChange = new EventEmitter<string>();
  @ViewChild('host', { read: ViewContainerRef, static: true }) host!: ViewContainerRef;

  private componentRef?: ComponentRef<DashboardWidgetComponent>;

  constructor(private readonly registry: DashboardWidgetRegistryService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['widget']) {
      this.render();
    }
  }

  ngOnDestroy(): void {
    this.clear();
  }

  private render(): void {
    this.clear();
    const registration = this.registry.get(this.widget.type);
    if (!registration) {
      return;
    }
    this.componentRef = this.host.createComponent(registration.component);
    this.componentRef.instance.config = this.widget;
    const instance = this.componentRef.instance as DashboardWidgetComponent & Partial<OnChanges>;
    if (typeof instance.ngOnChanges === 'function') {
      instance.ngOnChanges({
        config: new SimpleChange(undefined, this.widget, true)
      });
    }
    this.componentRef.changeDetectorRef.detectChanges();

    const componentRef = this.componentRef;
    Promise.resolve().then(() => {
      if(this.componentRef === componentRef) {
        this.titleChange.emit(componentRef.instance.title);
        this.iconChange.emit(componentRef.instance.icon);
      }
    });
  }

  private clear(): void {
    this.componentRef?.destroy();
    this.componentRef = undefined;
    this.host.clear();
  }
}
